var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconResiduoValorizado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon-residuo-valorizado"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-residuo-valorizado",
    clipPath: "url(#clip-Icon-residuo-valorizado)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_835",
    "data-name": "Grupo 835",
    transform: "translate(-177 -324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_805",
    "data-name": "Grupo 805",
    transform: "translate(184.145 326.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_crop_square_24px",
    d: "M20.193,4H2.523C.9,4-.15,5.326-.488,6.929L-3.734,24.32A2.954,2.954,0,0,0-.79,27.265H23.629a2.954,2.954,0,0,0,2.945-2.945L23.137,6.945C22.631,5.139,21.812,4,20.193,4Zm3.437,20.32H-.79L2.523,6.945H20.193Z",
    transform: "translate(3.734 7.566)",
    fill: "#43A7B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_people_outline_24px",
    d: "M19.581,19.252a7.126,7.126,0,1,0-7.126-7.126A7.134,7.134,0,0,0,19.581,19.252Zm0-11.2a4.072,4.072,0,1,1-4.072,4.072A4.084,4.084,0,0,1,19.581,8.054Z",
    transform: "translate(-4.352 -5)",
    fill: "#43A7B6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResiduoValorizado);
export default __webpack_public_path__ + "static/media/icon-residuo-valorizado.48cb1e261b1d867d82d385909a368c45.svg";
export { ForwardRef as ReactComponent };